import { Routes } from '@angular/router';
import { Login } from './components/auth/login/login';
import { MainLayout } from './components/main-layout/main-layout';
import { authGuard } from './guards/auth-guard';
import { loginGuard } from './guards/login-guard';
import { Dashboard } from './components/dashboard/dashboard';
import { Plans } from './components/setting/plans/plans';
import { Iot } from './components/iot/iot';
import { ModelsListComponent } from './components/vehicles/models/models-list-component/models-list-component';
import { AddModelForm } from './@shared/forms/vehicles/models/add-model-form/add-model-form';
import { CarDetailsComponent } from './components/vehicles/cars/car-details-component/car-details-component';
import { EmployeesList } from './components/employees/employees-list/employees-list';
import { CustomersList } from './components/customers/customers-list/customers-list';
import { ModelDetails } from './components/vehicles/models/model-details/model-details';
import { CustomerDetails } from './components/customers/customer-details/customer-details';
import { RidesList } from './components/rides/rides-list/rides-list';
import { RideVerificationList } from './components/ride-verification/ride-verification-list/ride-verification-list';
import { AnalysisComponent } from './components/analysis-component/analysis-component';
import { EmployeeActivityLogList } from './components/setting/employee-activity-log/employee-activity-log-list/employee-activity-log-list';
import { PaymentHistoryList } from './components/transaction-hstory/payment-history-list/payment-history-list';
import { WalletHistoryList } from './components/transaction-hstory/wallet-history-list/wallet-history-list';
import { PaymentWebhookList } from './components/setting/webhooks/payment-webhook/payment-webhook';
import { UserRole } from './models/enums';
import { RideDetails } from './components/rides/ride-details/ride-details';
import { ReservationList } from './components/reservations/reservation-list/reservation-list';
import { CarsComponent } from './components/vehicles/cars/cars-component/cars-component';
import { DamageReportsList } from './components/damage-reports/damage-reports-list/damage-reports-list';
import { AlertsPage } from './components/alerts/alerts-page/alerts-page';
import { TopicsPage } from './components/topics/topics-page/topics-page';
import { CustomerGroupsPage } from './components/customer-groups/customer-groups-page/customer-groups-page';
import { CustomerGroupDetail } from './components/customer-groups/customer-group-detail/customer-group-detail';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/login'
    },
    {
        path: "login",
        component: Login,
        canActivate: [loginGuard],
        title: "Login",
    },
    {
        path: '',
        pathMatch: 'prefix',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        component: MainLayout,
        children: [
            {
                path: "dashboard",
                pathMatch: 'full',
                title: "Dashboard",
                component: Dashboard,
                data: {
                    roles: [UserRole.ADMIN, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR, UserRole.FLEET_MANAGER, UserRole.SUPER_ADMIN]
                }
            },
            {
                path: "iot",
                pathMatch: 'full',
                title: "IOT",
                component: Iot,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN]
                }
            },
            {
                path: "alerts",
                pathMatch: 'full',
                title: "Alerts",
                component: AlertsPage,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN]
                }
            },
            {
                path: "campaigns",
                pathMatch: 'full',
                title: "Campaigns",
                component: TopicsPage,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN]
                }
            },
            {
                path: "iot-data-log",
                pathMatch: 'full',
                redirectTo: '/iot',
            },
            {
                path: "manage-iot",
                pathMatch: 'full',
                redirectTo: '/iot',
            },
            {
                path: "plans",
                pathMatch: 'full',
                title: "Plans",
                component: Plans,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN]
                }
            },
            {
                path: "payment-webhook",
                pathMatch: 'full',
                title: "Payment webhook",
                component: PaymentWebhookList,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN]
                }
            },
            {
                path: "employee-activity-log",
                pathMatch: 'full',
                title: "Employee activity log",
                component: EmployeeActivityLogList,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN]
                }
            },
            {
                path: 'models',
                title: "Models",
                data: {
                    roles: [UserRole.ADMIN, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR, UserRole.DRIVER, UserRole.FLEET_MANAGER, UserRole.SUPER_ADMIN]
                },
                children: [
                    { path: '', pathMatch: 'full', component: ModelsListComponent },
                    { path: ':id', pathMatch: 'full', component: ModelDetails }
                ]
            },
            {
                path: 'model-form',
                title: "Models",
                data: {
                    roles: [UserRole.ADMIN, UserRole.CS_SUPERVISOR, UserRole.SUPER_ADMIN]
                },
                children: [
                    { path: '', pathMatch: 'full', component: AddModelForm },
                    { path: ':id', pathMatch: 'full', component: AddModelForm }
                ]
            },
            {
                path: 'vehicles',
                title: "Vehicles",
                data: {
                    roles: [UserRole.ADMIN, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR, UserRole.DRIVER, UserRole.FLEET_MANAGER, UserRole.SUPER_ADMIN]
                },
                children: [
                    { path: '', pathMatch: 'full', component: CarsComponent },
                    { path: ':id', pathMatch: 'full', component: CarDetailsComponent }
                ]
            },
            {
                path: "employees",
                pathMatch: 'full',
                title: "Employees",
                component: EmployeesList,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.FLEET_MANAGER]
                }
            },
            {
                path: 'customers',
                title: "Customers",
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.FLEET_MANAGER, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR]
                },
                children: [
                    { path: '', pathMatch: 'full', component: CustomersList },
                    { path: ':id', pathMatch: 'full', component: CustomerDetails }
                ]
            },
            {
                path: 'damage-reports',
                title: "Damage Reports",
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.FLEET_MANAGER, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR]
                },
                children: [
                    { path: '', pathMatch: 'full', component: DamageReportsList },
                ]
            },
            {
                path: 'rides',
                title: "Rides",
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.FLEET_MANAGER, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR, UserRole.DRIVER]
                },
                children: [
                    { path: '', pathMatch: 'full', component: RidesList },
                    { path: ':id', pathMatch: 'full', component: RideDetails }
                ]
            },
            {
                path: "ride-verification",
                pathMatch: 'full',
                title: "Ride verification",
                component: RideVerificationList,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.FLEET_MANAGER, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR]
                },
            },
            {
                path: "payment-transaction-history",
                pathMatch: 'full',
                title: "Payment transaction history",
                component: PaymentHistoryList,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR]
                },
            },
            {
                path: "wallet-transaction-history",
                pathMatch: 'full',
                title: "Wallet transaction history",
                component: WalletHistoryList,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR]
                },
            },
            {
                path: "analysis",
                pathMatch: 'full',
                title: "Analysis",
                component: AnalysisComponent,
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.CS_SUPERVISOR]
                }
            },
            {
                path: 'customer-groups',
                title: "Customer Groups",
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN]
                },
                children: [
                    { path: '', pathMatch: 'full', component: CustomerGroupsPage },
                    { path: ':id', pathMatch: 'full', component: CustomerGroupDetail }
                ]
            },
            {
                path: 'reservations',
                title: "Reservations",
                data: {
                    roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.FLEET_MANAGER, UserRole.CS_AGENT, UserRole.CS_SUPERVISOR, UserRole.DRIVER]
                },
                children: [
                    { path: '', pathMatch: 'full', component: ReservationList },
                ]
            },
        ]
    }
];
